import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Title,
  Text,
  Center,
  SimpleGrid,
  ThemeIcon,
  useMantineTheme,
} from '@mantine/core';

import * as classes from './FeatureBlockCompact.module.css';
import ButtonBlock from '../ButtonBlock';
import ICONS_MAP from '../FeatureBlock/IconsMap';


function FeatureBlockCompact({
  featuresSottotitolo,
  featuresTitolo,
  featuresButtons,
  featuresList,
  stile,
}) {
  const { colors } = useMantineTheme();

  return (
    <Container fluid style={{ backgroundColor: stile?.coloreDiSfondo ? colors[stile?.coloreDiSfondo][1] : 'inherit' }}>
      <Container p="lg">
        {featuresTitolo && (
          <Title order={2} size="h1" className={classes.title} ta="center" mt="sm">
            {featuresTitolo}
          </Title>
        )}

        {featuresSottotitolo && (
          <Container>
            <Text className={classes.description} size="sm">
              {featuresSottotitolo}
            </Text>
          </Container>
        )}

        <SimpleGrid
          mt={60}
          cols={{ base: 1, xs: 2, md: 3 }}
          spacing={{ base: 'xl', md: 50 }}
          verticalSpacing={{ base: 'xl', md: 50 }}
        >
          {featuresList.map(({ bloccoFeatureTitolo, bloccoFeatureIcona, bloccoFeatureDescrizione }, key) => {
            const Ico = ICONS_MAP[bloccoFeatureIcona];

            return (
              <div key={`feat_${key + 1}`}>
                {Ico && (
                  <ThemeIcon variant="light" size={40} radius={40} color="secondary">
                    <Ico
                      style={{ width: '70%', height: '70%' }}
                      stroke={1.5}
                      color={colors[stile?.coloreDiSfondo ? stile?.coloreDiSfondo : 'secondary'][5]}
                    />
                  </ThemeIcon>
                )}
                <Text mt="sm" mb={7}>
                  {bloccoFeatureTitolo}
                </Text>
                <Text size="sm" className={classes.dimmed} lh={1.6}>
                  {bloccoFeatureDescrizione}
                </Text>
              </div>
            );
          })}

        </SimpleGrid>
        {!!featuresButtons?.length && (
          <Center mt="md" mb="xl">
            <ButtonBlock buttons={featuresButtons} />
          </Center>
        )}
      </Container>
    </Container>
  );
}

FeatureBlockCompact.propTypes = {
  featuresTitolo: PropTypes.string,
  featuresSottotitolo: PropTypes.string,
  featuresButtons: PropTypes.array,
  featuresList: PropTypes.array,
};

export default FeatureBlockCompact;
